module.exports = __webpack_public_path__ + "img/layers.ad5a2d22.svg";